// Popup Manager with localStorage
const PopupManager = {
    storageKey: 'fria_popup_dismissed',
    dateStorageKey: 'fria_popup_dismissed_date',

    shouldShow() {
        try {
            const dismissedUntil = localStorage.getItem(this.storageKey);
            const dismissedDate = localStorage.getItem(this.dateStorageKey);

            // If no dismissal data, show popup
            if (!dismissedUntil || !dismissedDate) return true;

            // Get today's date string (YYYY-MM-DD)
            const today = new Date().toISOString().split('T')[0];

            // If it's a new day since dismissal, clear storage and show popup
            if (dismissedDate !== today) {
                localStorage.removeItem(this.storageKey);
                localStorage.removeItem(this.dateStorageKey);
                return true;
            }

            // Check if enough time has passed (fallback)
            return Date.now() > parseInt(dismissedUntil);
        } catch (e) {
            return true; // Fallback if localStorage doesn't work
        }
    },

    dismiss() {
        try {
            const today = new Date().toISOString().split('T')[0];
            const hideUntil = Date.now() + (24 * 60 * 60 * 1000); // Hide for 24 hours as fallback

            localStorage.setItem(this.storageKey, hideUntil.toString());
            localStorage.setItem(this.dateStorageKey, today);
        } catch (e) {
            console.warn('Could not save popup state to localStorage');
        }
    }
};

document.addEventListener("DOMContentLoaded", function () {
    const languageSwitcher = document.querySelector('.wpml-ls-current-language');
    if (languageSwitcher) {
        languageSwitcher.addEventListener('click', function (e) {
            e.preventDefault(); // Förhindra standardlänk-klick
            const subMenu = this.querySelector('.sub-menu');
            if (subMenu) {
                const isVisible = subMenu.style.display === 'block';
                subMenu.style.display = isVisible ? 'none' : 'block';
            }
        });
    }

    const ua = navigator.userAgent;
    const isSafari = /^((?!chrome|android|crios|fxios).)*safari/i.test(ua);
    const isAppleDevice = /(Macintosh|iPad)/i.test(ua); // includes iPads with desktop UA

    if (isSafari && isAppleDevice) {
        document.documentElement.classList.add("mac-safari");
    }

    // Site Overlay Popup functionality
    const overlay = document.getElementById('site-overlay');
    const closeBtn = overlay?.querySelector('.overlay-close');
    let previousActiveElement = null;

    // Show overlay on page load only if should show
    if (overlay && PopupManager.shouldShow()) {
        // Store previously focused element
        previousActiveElement = document.activeElement;

        overlay.classList.add('active');
        overlay.setAttribute('aria-hidden', 'false');

        // Ensure popup is focusable for keyboard navigation
        const overlayPopup = overlay.querySelector('.overlay-popup');
        if (overlayPopup) {
            overlayPopup.setAttribute('tabindex', '0');
        }
    }

    // Function to close overlay
    function closeOverlay() {
        // Save dismissal state to localStorage
        PopupManager.dismiss();

        // First blur any focused elements inside the overlay
        const focusedElement = overlay.querySelector(':focus');
        if (focusedElement) {
            focusedElement.blur();
        }

        overlay.style.opacity = '0';

        setTimeout(() => {
            overlay.classList.remove('active');
            overlay.setAttribute('aria-hidden', 'true');
            // Return focus to previously focused element
            if (previousActiveElement) {
                previousActiveElement.focus();
            }
        }, 300);
    }

    // Close overlay functionality
    if (closeBtn) {
        closeBtn.addEventListener('click', closeOverlay);
    }

    // Close overlay when clicking outside (but not on Cookiebot)
    if (overlay) {
        overlay.addEventListener('click', function (e) {
            // Check if click is on any of the overlay content elements that should prevent closing
            const preventCloseElements = overlay.querySelectorAll('.overlay-popup, .overlay-image, .overlay-image-link, .overlay-close');
            for (let element of preventCloseElements) {
                if (element.contains(e.target)) {
                    return;
                }
            }

            closeOverlay();
        });
    }

    // Close overlay with ESC key and redirect focus to overlay
    document.addEventListener('keydown', function (e) {
        if (overlay?.classList.contains('active')) {
            if (e.key === 'Escape') {
                closeOverlay();
                return;
            }

            // Redirect all tab navigation to overlay when active
            if (e.key === 'Tab') {
                e.preventDefault();

                const focusableElements = overlay.querySelectorAll(
                    'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
                );

                if (focusableElements.length === 0) return;

                const firstFocusable = focusableElements[0];
                const lastFocusable = focusableElements[focusableElements.length - 1];

                // If no element in overlay is focused, focus the first one
                if (!overlay.contains(document.activeElement)) {
                    firstFocusable.focus();
                    return;
                }

                if (e.shiftKey) {
                    if (document.activeElement === firstFocusable) {
                        lastFocusable.focus();
                    } else {
                        const currentIndex = Array.from(focusableElements).indexOf(document.activeElement);
                        if (currentIndex > 0) {
                            focusableElements[currentIndex - 1].focus();
                        }
                    }
                } else {
                    if (document.activeElement === lastFocusable) {
                        firstFocusable.focus();
                    } else {
                        const currentIndex = Array.from(focusableElements).indexOf(document.activeElement);
                        if (currentIndex >= 0 && currentIndex < focusableElements.length - 1) {
                            focusableElements[currentIndex + 1].focus();
                        } else {
                            firstFocusable.focus();
                        }
                    }
                }
            }
        }
    });

    // Handle overlay image click - close overlay and navigate to link
    const overlayImageLink = overlay?.querySelector('.overlay-image-link');
    if (overlayImageLink) {
        overlayImageLink.addEventListener('click', function (e) {
            e.preventDefault(); // Prevent default navigation
            const url = this.getAttribute('href');

            // Save dismissal state to localStorage (user clicked on offer)
            PopupManager.dismiss();

            // First blur the focused element (this link)
            this.blur();

            // Close overlay first
            overlay.style.opacity = '0';

            setTimeout(() => {
                overlay.classList.remove('active');
                overlay.setAttribute('aria-hidden', 'true');
                // Return focus to previously focused element
                if (previousActiveElement) {
                    previousActiveElement.focus();
                }
                // Navigate after overlay is closed
                if (url) {
                    window.location.href = url;
                }
            }, 300);
        });
    }

});
